import React from 'react'
import { useLocation } from 'react-router-dom'
import { ElegibilidadProvider } from '../../../../../context/ElegibilidadContext'
import { EligibilityContextProvider } from '../../../../../context/EligibilityContext'
import ElegibilidadFormEdit from './ElegibilidadEdit'
// import { FormContextProvider } from '../../../../../context/formContext'
// import Toast from '../../../../../components/Toast/Toast'
const FormElegibilidadEdit = () => {
  const location = useLocation()
  return (
    <ElegibilidadProvider>
      <EligibilityContextProvider>
        <ElegibilidadFormEdit idForm={location.state} />
      </EligibilityContextProvider>
    </ElegibilidadProvider>
  )
}

export default FormElegibilidadEdit
